// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"d9ab5704","799":"908a2e3a","936":"e7875b56"}[chunkId] + ".chunk.js";
};